import * as React from 'react';
import { Box, CSS } from '@ghq-abi/design-system';

type IconButtonProps = {
  title?: string;
  disabled?: boolean;
  css?: CSS;
  onClick: React.MouseEventHandler<HTMLDivElement>;
  onTouchEnd?: React.TouchEventHandler<HTMLDivElement>;
  icon: React.ReactNode;
};

export function IconButton({
  title,
  disabled,
  css,
  icon,
  onClick,
  onTouchEnd,
}: IconButtonProps) {
  return (
    <Box
      css={{
        height: '$4',
        pointerEvents: disabled ? 'none' : 'all',
        cursor: disabled ? 'not-allowed' : 'pointer',
        color: disabled ? '$gray450' : '$gray800',
        ...css,
      }}
      role="button"
      title={title}
      onClick={onClick}
      aria-disabled={disabled}
      onTouchEnd={onTouchEnd}
    >
      {icon}
    </Box>
  );
}
